import { ALERT_UI_STATES, POLICY_APPLICATIONS } from '@kentik/ui-shared/alerting/constants';

export const fetchAlertsParameters = {
  states: [ALERT_UI_STATES.ACTIVE, ALERT_UI_STATES.CLEAR],
  applications: [POLICY_APPLICATIONS.NMS],
  lookback: 604800,
  sorting: {
    fields: [
      {
        name: 'start_time',
        order: 'SORT_ORDER_DESCENDING'
      }
    ]
  }
  // limit: 1000
};
